export default __webpack_public_path__ + "static/media/img-0176-spain-half-face.6f4da1e4.png";